// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"3624d8c7","436":"ce7efdee","548":"b105250c","720":"b4f1e569","945":"e6a8cbd9"}[chunkId] + ".chunk.js";
};